// Presentation scope only. Credentials and tenant access stay on the server.
export function monitorProjectPrefix(instance) {
  if (!instance || instance.policyInheritanceError) return "";
  const entries = Array.isArray(instance.policyCredentials)
    ? instance.policyCredentials.filter(entry => typeof entry?.username === "string" && entry.username.trim())
    : [];
  // A primary transport user does not turn a multi-project master into a project.
  if (entries.length !== 1 || typeof entries[0].key !== "string") return "";
  return entries[0].key.trim().replace(/_+$/, "").toUpperCase();
}

export function matchesMonitorProject(flow, prefix) {
  return !prefix || [flow?.name, flow?.id, flow?.displayName].some(value =>
    typeof value === "string" && value.toUpperCase().includes(prefix));
}
